import React, { useEffect } from "react";
import {
  makeStyles,
  ClickAwayListener,
  Checkbox,
  InputLabel,
} from "@material-ui/core";
import { KTextInput } from "@kyburz/kdesign-system";
import useSetState from "../../hooks/useSetState";

interface DrivingCategory {
  label: string;
}
interface Props {
  onChange: (v) => void | any;
  placeholder?: string;
  elements?: any;
  style?: any;
  label?: string;
  required?: boolean;
  value?: any;
}

const KCheckboxSelect: React.FC<Props> = ({
  onChange,
  placeholder = "",
  elements = [],
  style = {},
  label = "",
  required = false,
  value = [],
}: Props) => {
  const [{ checked, open }, setState] = useSetState({
    checked: [],
    open: false,
  });

  const useStyles = makeStyles((theme) => ({
    title: {
      fontSize: "14px",
      lineHeight: 1.429,
      color: "#383F51",
    },
    inputBase: {
      width: 192,
      background: "white",
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: 4,
      "& input": {
        borderRadius: 4,
        backgroundColor: theme.palette.common.white,
        padding: 8,
        height: 19,
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        fontSize: 14,
        "&:focus": {
          borderColor: theme.palette.primary.main,
        },
      },
    },

    popup: {
      width: 200,
      display: open ? "flex" : "none",
      position: "absolute",
      background: "white",
      zIndex: 1,
      borderRadius: 4,
      boxShadow: "0 3px 12px rgba(27,31,35,.15)",
      flexWrap: "wrap",
    },
    color: {
      margin: 0,
      padding: 0,
      color: theme.palette.grey[300],
      "&$checked": {
        color: theme.palette.primary.main,
      },
    },
    checked: {},
  }));

  const classes = useStyles();
  const handleCheck = (newValue: DrivingCategory): void => {
    if (
      !checked.map((x: DrivingCategory) => x?.label).includes(newValue?.label)
    )
      setState({ checked: [...checked, newValue] });
    else
      setState({
        checked: checked.filter(
          (y: DrivingCategory) => y?.label !== newValue?.label,
        ),
      });
  };

  const toggleOpen = () => {
    setState({ open: !open });
  };

  const closePopup = () => {
    setState({ open: false });
  };

  useEffect(() => {
    onChange(checked.map((x) => x.label));
  }, [checked]);

  useEffect(() => {
    const mappedValue =
      value.length > 0 ? value.map((x) => ({ label: x })) : [];
    if (
      mappedValue.length > 0 &&
      JSON.stringify(mappedValue) !== JSON.stringify(checked) &&
      mappedValue[0]
    ) {
      setState({ checked: mappedValue });
    }
  }, [value]);

  return (
    <ClickAwayListener onClickAway={() => closePopup()}>
      <div style={{ ...style, width: 192 }}>
        <div onClick={() => toggleOpen()}>
          <KTextInput
            placeholder={placeholder}
            required={required}
            label={label}
            onChange={() => {}}
            width="192px"
            value={checked.length > 0 ? checked.map((x) => x.label) : ""}
            endIcon="chevron-down"
          />
        </div>
        <div className={classes.popup}>
          {elements.map((x) => (
            <div
              key={x.label}
              style={{
                padding: 8,
                width: 60,
                justifyContent: "flex-end",
                display: "flex",
                flexDirection: "row-reverse",
              }}
            >
              <InputLabel className={classes.title}>{x.label}</InputLabel>
              <Checkbox
                key={x.label}
                onChange={() => handleCheck(x)}
                name={x.label}
                checked={!!checked.some((y) => y.label === x.label)}
                classes={{ root: classes.color, checked: classes.checked }}
              />
            </div>
          ))}
        </div>
      </div>
    </ClickAwayListener>
  );
};

export default KCheckboxSelect;
